import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "flex mx-auto my-10" }
const _hoisted_3 = { class: "flex-1 ml-8 relative bg-white border border-gray-200 rounded-lg shadow" }
const _hoisted_4 = { class: "max-h-150 overflow-y-scroll p-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute bottom-0 left-0 right-0 h-10 mx-10",
  style: {"background":"linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%)"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSelectDropdown = _resolveComponent("BaseSelectDropdown")!
  const _component_SidebarNavigationLink = _resolveComponent("SidebarNavigationLink")!
  const _component_SidebarNavigationGroup = _resolveComponent("SidebarNavigationGroup")!
  const _component_SidebarNavigation = _resolveComponent("SidebarNavigation")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.showLayout ? 'DefaultLayout' : 'div'), null, {
    default: _withCtx(() => [
      _createElementVNode("section", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_SidebarNavigation, null, {
              default: _withCtx(() => [
                (_ctx.allLegalRegions.length > 1)
                  ? (_openBlock(), _createBlock(_component_BaseSelectDropdown, {
                      key: 0,
                      modelValue: _ctx.selectedRegionId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedRegionId) = $event)),
                      options: _ctx.legalRegionsDropdownOptions,
                      placeholder: _ctx.$t('platform.legal.country-dropdown.placeholder')
                    }, null, 8, ["modelValue", "options", "placeholder"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_SidebarNavigationGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_SidebarNavigationLink, {
                      to: { name: `${_ctx.routePrefix}legal-privacy-policy`, params: { region: _ctx.selectedRegionId } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('platform.legal.privacy-policy.title')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_SidebarNavigationLink, {
                      to: { name: `${_ctx.routePrefix}legal-terms-service`, params: { region: _ctx.selectedRegionId } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('platform.legal.terms-service.title')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_RouterView, null, {
                  default: _withCtx(({ Component }) => [
                    _createVNode(_Transition, {
                      name: "fade",
                      mode: "out-in"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { branding: _ctx.branding }, null, 8, ["branding"]))
                      ]),
                      _: 2
                    }, 1024),
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _hoisted_6
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}